var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-progress-circular',{class:_vm.center ? 'center' : '',attrs:{"indeterminate":"","color":"primary"}}),(_vm.loadingText)?_c('div',{staticClass:"loading-text",style:(`text-align: ${_vm.center ? 'center' : 'inherit'}`)},[_vm._v(" "+_vm._s(_vm.loadingText)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }